import { IChatCaseData, IChatQueueType } from '../../interfaces/case-details-api-interfaces';
import { IUserData } from '../../interfaces/app-interfaces';
import { getBrowserName, getDeviceType, getGaAnonymousId } from '../app-utils';
import { getPreChatInfoFromLocalStorage, getRestId } from '../session-storage-utils';
import { isStudioPage } from '../chat/page-utils';

export const getRoutingAttributes = (
  customData: {
    chatbotIdentifier?: string;
    orderNumber?: string;
    selectedProductIds?: string[];
    userShopperId?: string;
    chatbotContactReason?: string;
    studioDesignLink?: string;
    isLoggedIn: string;
  },
  caseData: IChatCaseData,
  queueId: string,
  queueName: IChatQueueType,
  userData?: IUserData,
) => {
  const customerDatafromLocalStorage = getPreChatInfoFromLocalStorage();

  const updatedCustomerData = {
    firstName: userData?.firstName || '',
    lastName: userData?.lastName || '',
    email: userData?.email || '',
  };

  if (!updatedCustomerData.email || updatedCustomerData.email.length === 0) {
    updatedCustomerData.email = customerDatafromLocalStorage.email || '';
  }
  if (!updatedCustomerData.firstName || updatedCustomerData.firstName.length === 0) {
    updatedCustomerData.firstName = customerDatafromLocalStorage.firstName || '';
  }
  if (!updatedCustomerData.lastName || updatedCustomerData.lastName.length === 0) {
    updatedCustomerData.lastName = customerDatafromLocalStorage.lastName || '';
  }
  if (!updatedCustomerData.firstName || updatedCustomerData.firstName.length === 0) {
    // Fallback to email  if first name is still not available
    updatedCustomerData.firstName = updatedCustomerData.email;
  }
  if (!updatedCustomerData.lastName || updatedCustomerData.lastName.length === 0) {
    // Fallback to first name, email  if last name is still not available
    updatedCustomerData.lastName = updatedCustomerData.firstName || updatedCustomerData.email;
  }

  const subject = customData.chatbotIdentifier ? `VA - ${caseData.pageName}` : caseData.subject || 'VA - Home Page';
  const description = customData.chatbotIdentifier ? `${caseData.pageName} - VA Case` : caseData.description || 'Help Center - VA Case';

  const requestData: Record<string, string> = {
    _firstName: updatedCustomerData?.firstName || updatedCustomerData?.email,
    _lastName: updatedCustomerData?.lastName || updatedCustomerData?.firstName || updatedCustomerData?.email || 'Customer',
    _email: updatedCustomerData?.email,

    userShopperId: customData.userShopperId || '',
    chatbotIdentifier: customData.chatbotIdentifier || '',
    chatLocale: caseData.chatLocale || '',
    brand: caseData.brand || 'VP',
    banner: caseData.banner || 'VP',
    priority: queueName === 'checkout' ? 'High' : caseData.priority || 'Medium',
    pageName: caseData.pageName || 'Home Page:Help Center',
    pageURL: window?.location?.href?.split('?')?.[0] || '',
    category: caseData.category || 'Others',
    subCategory: caseData.subCategory || 'Others',
    caseOrigin: `${caseData.caseOrigin}${customData.chatbotIdentifier ? '-VA' : ''}`,
    status: caseData.status || 'In Progress',
    pageSection: caseData.pageSection || 'Home Page',
    pageStage: caseData.pageStage || 'Customer Care',
    subject,
    description,
    pagePath: window?.location.pathname || '',
    queueId: queueId || '',
    BrowserPlatform: navigator.platform || '',
    nrLogKey: getRestId() || '',
    gaAnonymousId: getGaAnonymousId() || '',
    referrerURL: document?.referrer?.split('?')?.[0] || '',
    orderNumber: customData.orderNumber || '',
    isLoggedIn: customData.isLoggedIn,
    selectedProductIds: customData.selectedProductIds ? customData.selectedProductIds.slice(0, 3).join(',') : '',
    device_type: getDeviceType() || '',
    browser: getBrowserName() || '',
    chatbotContactReason: customData.chatbotContactReason || '',
  };

  if (isStudioPage()) {
    requestData.liveDesignURL = customData.studioDesignLink || '';
  }

  return requestData;
};
